export const lockTypeConfig = {
  heading: "Locks and access",
  subtitle:
    "How does the guest get into your property? Add one or more locks (building entrance, unit…), each with its own name and access type.",
  loading: "Loading configuration…",

  enable: {
    title: "Send access codes",
    sub:
      "If you turn this off we won't send access keys to the guest. Arrival instructions will still be sent regardless of this setting.",
  },

  scope: {
    labelRoom: "Room to configure",
    labelUnit: "Unit to configure",
    hintRoom: "Each room keeps its own access configuration.",
    hintUnit: "Each unit keeps its own access configuration.",
  },

  conflict: {
    title: "These spaces won't use this configuration",
    textBefore:
      "They keep their own keys, and when sending them the most specific configuration always wins.",
    textStrong: "What you edit here won't reach them",
    textAfter: "while they stay like this:",
    lockCount: "lock | locks",
    applying: "Applying…",
    applyAll: "Apply this configuration to all",
  },

  lockBadge: "Lock {n}",
  removeLock: "Remove lock",
  nameLabel: "Entrance name",
  namePlaceholder: "Or type a name…",
  typeLabel: "Access type",
  codePlaceholderBox: "Key safe code · e.g. 5817",
  codePlaceholderLock: "Lock code · e.g. 5817",
  lockFallback: "Lock",
  connectedSuffix: "connected",
  editConfig: "Edit configuration",
  configure: "Configure…",
  addLock: "Add another lock",
  roomsHint:
    "Each physical room has its own lock and code. Configure them here, one by one.",

  wa: {
    online: "online",
    today: "Today",
    captionOverriding: "This is how {source} receives it · not the spaces noted above",
    captionPreview: "Preview · this is how the guest of {source} will receive it",
  },

  modal: {
    title: "Set up your smart lock",
    sub: "Choose your brand and connect it to generate automatic keys per booking.",
    close: "Close",
    note: "First add a unit to the listing to set up the smart lock.",
  },

  providerOther: "Other brand",

  presets: {
    main: "Main entrance",
    property: "Property entrance",
    unit: "Unit entrance",
  },

  entryFallback: "Entrance",
  roomFallback: "Room",
  yourProperty: "your property",

  types: {
    none: {
      title: "Key safe",
      desc: "A security box with the property keys.",
    },
    dynamic: {
      title: "Smart lock",
      desc: "A new automatic key for each booking.",
    },
    static: {
      title: "Lock with static code",
      desc: "A code you change manually from time to time.",
    },
  },

  source: {
    room: "this room",
    unit: "this property",
    property: "the listing",
  },

  preview: {
    boxText:
      "🔑 *{label} · {name}*\n\nThe key safe opens with the code: *{code}*\n\nInside you'll find the property keys. Please leave them there again when you leave.",
    dynamicText:
      "🔒🔑 *{label} · {name}*\n\nYour access code is: *58117*\n\nValid throughout your stay.",
    staticText:
      "🔒🔑 *{label} · {name}*\n\nThe lock code is: *{code}*\n\nUse it to open the property door.",
  },

  summary: {
    dynamic: "Smart lock",
    codePrefix: "Code {code}",
    staticCode: "Fixed code",
    boxPrefix: "Key safe {code}",
    empty: "Not set up",
  },

  toast: {
    saved: "Access saved",
    saveError: "The access method couldn't be saved.",
    unified: "Configuration unified",
    unifyError: "The configuration couldn't be unified.",
    savedRoom: "Access saved · {room}",
    saveErrorRoom: "Couldn't save access for {room}.",
    theRoom: "the room",
  },
};
